var _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1021,
    height: 820,
    viewBox: "0 0 1021 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1361_3235)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 499.299,
    cy: 667.133,
    rx: 394.993,
    ry: 76.1994,
    fill: "#EC407A",
    fillOpacity: 0.35
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.639 819.227C729.862 819.227 913.253 635.837 913.253 409.614C913.253 183.39 729.862 0 503.639 0C277.416 0 94.0254 183.39 94.0254 409.614C94.0254 635.837 277.416 819.227 503.639 819.227Z",
    fill: "url(#paint0_linear_1361_3235)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1361_3235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.759 277.206L495.749 522.168L144.738 277.206L466.061 52.872C474.775 46.7986 485.141 43.5425 495.763 43.5425C506.385 43.5425 516.752 46.7986 525.466 52.872L589.561 97.6806L606.343 109.334L775.322 227.328L793.123 239.827L846.759 277.206Z",
    fill: "url(#paint1_linear_1361_3235)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M438.674 482.341L144.738 691.351V277.206L438.674 482.341Z",
    fill: "url(#paint2_linear_1361_3235)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1361_3235)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.248,
    cy: 269.031,
    rx: 130.628,
    ry: 41.9874,
    fill: "#51823B",
    fillOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M552.851 482.341L846.787 691.351V277.206L552.851 482.341Z",
    fill: "url(#paint3_linear_1361_3235)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.738 691.351L465.682 463.171C474.466 456.916 484.98 453.555 495.763 453.555C506.546 453.555 517.061 456.916 525.844 463.171L846.759 691.351H144.738Z",
    fill: "url(#paint4_linear_1361_3235)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M673.289 241.921C683.088 241.921 689.931 235.233 689.931 225.901C689.931 216.57 683.088 209.882 673.289 209.882C663.647 209.882 656.648 216.57 656.648 225.901C656.648 235.233 663.647 241.921 673.289 241.921ZM686.665 204.127C686.665 193.24 691.953 189.041 700.041 184.841C710.928 179.242 719.015 170.066 719.015 157.002C719.015 137.56 700.507 123.874 675.778 123.874C649.649 123.874 630.985 139.271 629.119 160.89L659.136 166.333C660.225 156.379 666.135 149.07 674.534 149.07C681.222 149.07 686.354 153.735 686.354 160.112C686.354 166.489 680.599 170.066 675.622 173.332C664.735 180.487 660.069 188.574 660.069 204.127H686.665Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1361_3235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.826 202.162C128.014 227.334 70.1882 242.829 10.9998 247.937C18.9974 266.528 75.8225 359.588 244.509 436.267C249.069 436.969 354.406 387.966 412.213 354.362C410.249 357.168 232.653 291.819 181.826 202.162Z",
    fill: "url(#paint5_linear_1361_3235)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M671.283 304.01C735.966 304.01 788.403 251.573 788.403 186.89C788.403 122.206 735.966 69.7698 671.283 69.7698C606.599 69.7698 554.163 122.206 554.163 186.89C554.163 251.573 606.599 304.01 671.283 304.01Z",
    fill: "url(#paint6_linear_1361_3235)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M670.191 256.095C682.682 256.095 691.407 247.569 691.407 235.672C691.407 223.776 682.682 215.25 670.191 215.25C657.898 215.25 648.976 223.776 648.976 235.672C648.976 247.569 657.898 256.095 670.191 256.095ZM687.243 207.914C687.243 194.035 693.984 188.682 704.294 183.328C718.174 176.19 728.484 164.492 728.484 147.837C728.484 123.053 704.889 105.605 673.364 105.605C640.054 105.605 616.261 125.234 613.881 152.794L652.148 159.734C653.536 147.044 661.071 137.725 671.777 137.725C680.303 137.725 686.846 143.673 686.846 151.803C686.846 159.932 679.51 164.492 673.165 168.656C659.286 177.776 653.338 188.087 653.338 207.914H687.243Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.99 248.43C183.534 246.726 180.391 246.244 177.548 247.164L83.3602 277.636C79.9876 278.727 78.7859 282.881 81.0552 285.605V285.605C82.8826 287.798 85.8738 288.635 88.5743 287.71L185.181 254.621C187.882 253.696 188.337 250.058 185.99 248.43V248.43Z",
    fill: "#FCE4EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.358 285.946C181.97 283.703 178.543 282.956 175.438 284.001L110.26 305.937C107.386 306.904 106.371 310.45 108.298 312.791V312.791C109.873 314.704 112.467 315.441 114.813 314.643L183.188 291.362C185.496 290.576 186.136 287.615 184.358 285.946V285.946Z",
    fill: "#FCE4EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M219.342 304.522C216.85 302.526 213.498 301.974 210.498 303.065L135.42 330.351C132.474 331.422 131.587 335.16 133.739 337.441V337.441C135.385 339.186 137.912 339.781 140.164 338.955L218.408 310.242C220.841 309.349 221.364 306.142 219.342 304.522V304.522Z",
    fill: "#FCE4EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245.589 360.844C243.281 358.293 239.643 357.42 236.429 358.647L193.523 375.02C190.888 376.026 189.938 379.266 191.613 381.535V381.535C193.183 383.661 195.981 384.474 198.445 383.519L244.435 365.707C246.418 364.939 247.016 362.421 245.589 360.844V360.844Z",
    fill: "#FCE4EC"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1361_3235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.863 331.94C869.114 362.463 939.231 381.252 1011 387.446C1001.3 409.989 932.399 522.829 727.857 615.807C722.327 616.657 594.6 557.239 524.505 516.492C526.887 519.894 742.233 440.655 803.863 331.94Z",
    fill: "url(#paint7_linear_1361_3235)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M798.815 388.044C801.793 385.978 805.604 385.393 809.052 386.509L923.26 423.458C927.35 424.782 928.807 429.819 926.055 433.121V433.121C923.839 435.78 920.212 436.795 916.938 435.674L799.797 395.551C796.521 394.429 795.97 390.018 798.815 388.044V388.044Z",
    fill: "#FCE4EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M766.851 418.447C769.747 415.729 773.903 414.823 777.667 416.089L856.7 442.688C860.185 443.861 861.416 448.16 859.079 450.999V450.999C857.169 453.319 854.023 454.213 851.179 453.245L768.271 425.015C765.472 424.062 764.696 420.471 766.851 418.447V418.447Z",
    fill: "#FCE4EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M734.003 443.686C737.024 441.266 741.089 440.596 744.727 441.919L835.762 475.005C839.335 476.304 840.411 480.837 837.802 483.602V483.602C835.806 485.717 832.741 486.439 830.011 485.437L735.135 450.621C732.185 449.539 731.551 445.65 734.003 443.686V443.686Z",
    fill: "#FCE4EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M660.088 494.181C662.887 491.088 667.297 490.03 671.195 491.517L723.222 511.371C726.417 512.59 727.568 516.52 725.537 519.271V519.271C723.634 521.848 720.241 522.834 717.253 521.677L661.487 500.078C659.082 499.147 658.358 496.094 660.088 494.181V494.181Z",
    fill: "#FCE4EC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M694.111 467.176C697.152 465.269 700.903 464.874 704.273 466.106L824.219 509.962C828.05 511.363 828.979 516.358 825.906 519.042V519.042C823.874 520.817 821.035 521.341 818.503 520.408L694.739 474.816C691.447 473.604 690.982 469.139 693.954 467.274L694.111 467.176Z",
    fill: "#FCE4EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M271.503 316.801C268.996 315.228 265.902 314.902 263.123 315.919L164.203 352.087C161.044 353.242 160.278 357.362 162.812 359.575V359.575C164.488 361.039 166.829 361.471 168.917 360.702L270.986 323.102C273.701 322.102 274.084 318.42 271.633 316.882L271.503 316.801Z",
    fill: "#FCE4EC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M846.331 96.4157C846.331 107.718 837.169 116.881 825.866 116.881C814.564 116.881 805.402 107.718 805.402 96.4157C805.402 85.1132 814.564 75.9508 825.866 75.9508C837.169 75.9508 846.331 85.1132 846.331 96.4157Z",
    stroke: "url(#paint8_linear_1361_3235)",
    strokeWidth: 2.61276
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239.847 730.892C239.847 742.195 230.685 751.357 219.383 751.357C208.08 751.357 198.918 742.195 198.918 730.892C198.918 719.59 208.08 710.428 219.383 710.428C230.685 710.428 239.847 719.59 239.847 730.892Z",
    stroke: "url(#paint9_linear_1361_3235)",
    strokeWidth: 2.61276
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M765.468 765.104C765.468 776.407 756.306 785.569 745.003 785.569C733.701 785.569 724.538 776.407 724.538 765.104C724.538 753.802 733.701 744.639 745.003 744.639C756.306 744.639 765.468 753.802 765.468 765.104Z",
    stroke: "url(#paint10_linear_1361_3235)",
    strokeWidth: 2.61276
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M282.664 92.392C283.179 90.259 286.213 90.259 286.727 92.392L298.911 142.863C299.095 143.625 299.69 144.22 300.452 144.404L350.923 156.587C353.056 157.102 353.056 160.136 350.923 160.651L300.452 172.834C299.69 173.018 299.095 173.613 298.911 174.376L286.727 224.846C286.213 226.979 283.179 226.979 282.664 224.846L270.48 174.376C270.296 173.613 269.701 173.018 268.939 172.834L218.468 160.651C216.335 160.136 216.335 157.102 218.468 156.587L268.939 144.404C269.701 144.22 270.296 143.625 270.48 142.863L282.664 92.392Z",
    fill: "url(#paint11_linear_1361_3235)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M905.864 633.367C906.379 631.234 909.413 631.234 909.928 633.367L922.111 683.838C922.295 684.6 922.891 685.195 923.653 685.379L974.123 697.562C976.256 698.077 976.256 701.111 974.123 701.626L923.653 713.809C922.891 713.993 922.295 714.589 922.111 715.351L909.928 765.821C909.413 767.954 906.379 767.954 905.864 765.821L893.681 715.351C893.497 714.589 892.902 713.993 892.14 713.809L841.669 701.626C839.536 701.111 839.536 698.077 841.669 697.562L892.14 685.379C892.902 685.195 893.497 684.6 893.681 683.838L905.864 633.367Z",
    fill: "url(#paint12_linear_1361_3235)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.233 593.777C114.557 593.565 115.614 594.866 115.136 596.119L98.0695 640.807C97.5911 642.059 95.9361 642.324 95.0905 641.284L64.9226 604.16C64.077 603.119 64.6749 601.553 65.9989 601.341L113.233 593.777Z",
    fill: "url(#paint13_linear_1361_3235)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M911.075 279.682C910.743 278.382 911.943 277.212 913.234 277.574L959.286 290.516C960.577 290.878 960.991 292.503 960.031 293.439L925.798 326.851C924.838 327.787 923.224 327.334 922.893 326.035L911.075 279.682Z",
    fill: "url(#paint14_linear_1361_3235)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1361_3235",
    x: 82.5336,
    y: 569.16,
    width: 833.531,
    height: 195.945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8865,
    result: "effect1_foregroundBlur_1361_3235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1361_3235",
    x: 141.255,
    y: 43.5425,
    width: 708.988,
    height: 485.593,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.48368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1361_3235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1361_3235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1361_3235",
    x: 514.848,
    y: 205.27,
    width: 304.801,
    height: 127.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8865,
    result: "effect1_foregroundBlur_1361_3235"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1361_3235",
    x: 0.548963,
    y: 195.194,
    width: 422.115,
    height: 255.015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.48368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22552
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.168627 0 0 0 0 0.396078 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1361_3235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1361_3235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1361_3235",
    x: 504.42,
    y: 330.198,
    width: 516.106,
    height: 313.487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.28021,
    dy: 13.0638
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.40282
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.021441 0 0 0 0 0.168056 0 0 0 0 0.395833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1361_3235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1361_3235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1361_3235",
    x1: 500.482,
    y1: -133.38,
    x2: 508.873,
    y2: 1305.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCBDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBCD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1361_3235",
    x1: 495.749,
    y1: 43.5425,
    x2: 495.749,
    y2: 522.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFADC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1361_3235",
    x1: 291.706,
    y1: 277.206,
    x2: 291.706,
    y2: 691.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF72A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1361_3235",
    x1: 699.819,
    y1: 277.206,
    x2: 699.819,
    y2: 691.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF72A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1361_3235",
    x1: 495.749,
    y1: 453.555,
    x2: 495.749,
    y2: 691.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF71A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF568F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1361_3235",
    x1: 54.5423,
    y1: 306.353,
    x2: 317.352,
    y2: 255.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1361_3235",
    x1: 555.283,
    y1: 85.5297,
    x2: 788.546,
    y2: 304.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51823B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1361_3235",
    x1: 958.202,
    y1: 458.278,
    x2: 639.529,
    y2: 396.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1361_3235",
    x1: 799.106,
    y1: 82.8086,
    x2: 867.141,
    y2: 141.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF96BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1361_3235",
    x1: 192.622,
    y1: 717.285,
    x2: 260.657,
    y2: 776.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF96BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1361_3235",
    x1: 718.243,
    y1: 751.497,
    x2: 786.278,
    y2: 810.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF96BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1361_3235",
    x1: 284.696,
    y1: 83.9749,
    x2: 284.696,
    y2: 233.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF71A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF568F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1361_3235",
    x1: 907.896,
    y1: 624.95,
    x2: 907.896,
    y2: 774.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF71A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF568F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1361_3235",
    x1: 116.212,
    y1: 593.3,
    x2: 67.938,
    y2: 632.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF71A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF568F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1361_3235",
    x1: 910.329,
    y1: 276.758,
    x2: 953.776,
    y2: 321.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF71A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF568F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmail);
export default __webpack_public_path__ + "static/media/illustration_email.53fefd8637c7654d8ddb9e393aaf3c00.svg";
export { ForwardRef as ReactComponent };